import {
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Spinner,
    Text,
    useDisclosure
} from '@chakra-ui/react'
import { OrderPaymentForView } from '../../../../Sales/types'
import { ReactNode, useState } from 'react'
import { get } from '../../../../../lib/http'
import Content from '../../../../Sales/ModalContents/ModalView/ModalContent'

export interface OrderPaymentModalViewProps {
    orderPaymentId: number
    children: ReactNode
}

export default function OrderPaymentModalView({
    orderPaymentId,
    children
}: OrderPaymentModalViewProps) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [isLoading, setLoading] = useState(false)
    const [orderPayment, setOrderPayment] =
        useState<OrderPaymentForView | null>(null)

    async function openHandler() {
        onOpen()
        setLoading(true)
        const resp = await get<OrderPaymentForView>(
            `/api/v2/order_payments/${orderPaymentId}`
        )
        if (resp.data) {
            setOrderPayment(resp.data.result)
        }
        setLoading(false)
    }

    return (
        <>
            <Text
                textDecoration="underline"
                cursor="pointer"
                onClick={openHandler}
                fontFamily="Poppins"
                color="blue.400"
            >
                {children}
            </Text>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent px={6} py={4}>
                    <ModalBody pb={6}>
                        {isLoading ? (
                            <Flex justifyContent="center" py="12">
                                <Spinner size="xl" />
                            </Flex>
                        ) : (
                            <Content
                                orderPayment={
                                    orderPayment as OrderPaymentForView
                                }
                            />
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
